module.exports = __webpack_public_path__ + "ptc_nakagawa_C1.574eef79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_C1.jpg
// module id = juEV
// module chunks = 0